import axios from "~/plugins/axios";

export default {
  paginate(
    page = 1,
    perPage = 15,
    includes = [],
  ) {
    return axios.get("/web_api/v1/automation_action", {
      params: {
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  getById(automationActionId) {
    return axios
      .get(`/web_api/v1/automation_action/${automationActionId}`)
      .then((response) => response.data);
  },
};
